if (!customElements.get('xo-feature-chart')) {
  class XoFeatureChart extends HTMLElement {
    connectedCallback() {
      if (this.__featureChartBound) return;
      this.__featureChartBound = true;

      
      if (!document.getElementById('xo-feature-chart-loading-style')) {
        var style = document.createElement('style');
        style.id = 'xo-feature-chart-loading-style';
        style.textContent = '.xo-feature-chart__table.xo-loading { opacity: 0.6; pointer-events: none; transition: opacity 0.2s ease; }';
        document.head.appendChild(style);
      }

    
      this.lazyLoadTemplates();

      this.addEventListener('change', this.onChange.bind(this));
    }

    lazyLoadTemplates() {
      var tpls = document.querySelectorAll('template[id^="xo-entry-"]');
      tpls.forEach(function(t) {
        var imgs = t.content.querySelectorAll('img[src]');
        imgs.forEach(function(img) {
          img.setAttribute('data-src', img.getAttribute('src'));
          img.removeAttribute('src');
        });
      });
    }

    onChange(event) {
      var target = event.target;
      if (!target || !target.classList.contains('xo-comparison-dropdown')) return;

      var handle = target.value;
      var colType = target.getAttribute('data-column-type') || '';
      var safeType = colType.replace(/\s+/g, '_').replace(/\//g, '_') || 'none';

      var selectCol = target.closest('.xo-feature-chart__product');
      if (!selectCol) return;

      var allProductCols = Array.prototype.slice.call(
        this.querySelectorAll('.xo-feature-chart__product')
      );
      var columnIndex = allProductCols.indexOf(selectCol);
      if (columnIndex === -1) return;

      var sectionId = this.dataset.sectionId;
      var tplId = 'xo-entry-' + sectionId + '-' + safeType + '-' + handle;
      var tpl = document.getElementById(tplId);

      if (!tpl) {
        tpl = document.querySelector('template[id^="xo-entry-' + sectionId + '-"][id$="-' + handle + '"]');
      }

      if (!tpl) {
        console.warn('[FeatureChart] template not found for handle:', handle);
        return;
      }

      var table = this.querySelector('.xo-feature-chart__table');
      if (table) table.classList.add('xo-loading');

      try {
        var entryFragment = tpl.content.cloneNode(true);
        var entryWrap = document.createElement('div');
        entryWrap.appendChild(entryFragment);

        var splitMark = '<!-- @split/feature-chart-value-column-item-part -->';
        var allHtml = entryWrap.innerHTML;
        var parts = allHtml.split(splitMark);
        var productHtml = (parts[0] || '').trim();
        var valuesHtml = (parts[1] || '').trim();

        selectCol.innerHTML = productHtml;

        var lazyImgs = selectCol.querySelectorAll('img[data-src]');
        lazyImgs.forEach(function(img) {
          img.setAttribute('src', img.getAttribute('data-src'));
          img.removeAttribute('data-src');
        });

        var valueParts = valuesHtml.split('<!-- @split/value:start -->');
        var parsedValues = [];
        for (var i = 1; i < valueParts.length; i++) {
          var part = valueParts[i];
          var endIdx = part.indexOf('<!-- @split/value:end -->');
          parsedValues.push(endIdx >= 0 ? part.substring(0, endIdx).trim() : part.trim());
        }

        var valueCells = this.querySelectorAll(
          '.xo-feature-chart__value[data-column-index="' + columnIndex + '"]'
        );
        var cellArr = Array.prototype.slice.call(valueCells);
        cellArr.forEach(function (cell, idx) {
          cell.innerHTML = parsedValues[idx] || '—';
        });
      } finally {
        if (table) table.classList.remove('xo-loading');
      }
    }
  }

  customElements.define('xo-feature-chart', XoFeatureChart);
}